import { useMemo } from 'react';
import { Duration, formatDuration } from 'date-fns';

const SECONDS_PER_MINUTE = 60;
const SECONDS_PER_HOUR = 3600;

interface IFormattedDurationTextProps {
  duration: number;
  durationTimeUnit?: 'minutes' | 'hours' | 'seconds';
  format?: (keyof Duration)[];
}

export const FormattedDurationText = ({
  duration,
  durationTimeUnit = 'minutes',
  format = ['hours', 'minutes'],
}: IFormattedDurationTextProps) => {
  const fmtTimeLimitFormat = useMemo(() => {
    let durationInSeconds: number;

    switch (durationTimeUnit) {
      case 'hours':
        durationInSeconds = duration * SECONDS_PER_HOUR;
        break;
      case 'minutes':
        durationInSeconds = duration * SECONDS_PER_MINUTE;
        break;
      case 'seconds':
        durationInSeconds = duration;
        break;
      default:
        durationInSeconds = duration * SECONDS_PER_MINUTE; // default to minutes
    }

    return formatDuration(
      {
        hours: Math.floor(durationInSeconds / SECONDS_PER_HOUR),
        minutes: Math.floor((durationInSeconds % SECONDS_PER_HOUR) / SECONDS_PER_MINUTE),
        seconds: durationInSeconds % SECONDS_PER_MINUTE,
      },
      {
        format,
        delimiter: ' ',
      },
    );
  }, [duration, durationTimeUnit, format]);

  return <span>{fmtTimeLimitFormat}</span>;
};
